<template>
	<div class="address">
		<Tou></Tou>
		<div class="w1500 bj-0 p-60 mt-50 mb-60">
			<div class="montserRegular tit-30 biaotie flex a-center pb-35 mb-30"
				style="border-bottom: 1px solid #f2f2f2;"> <span class="mr-20"></span> 
				<!-- Add receiving address -->
				{{gudingziduan.PointsMall.Addreceivingaddress}}
			</div>
			<el-form class="adddressform" label-position="top" label-width="80px" :model="formLabelAlign">
				<el-form-item :label="gudingziduan.PointsMall.CountryRegion">
					<el-input class="inputs input1" v-model="formLabelAlign.country"></el-input>
				</el-form-item>
				<el-form-item :label="gudingziduan.PointsMall.DAddress">
					<el-input class="input2" type="textarea" v-model="formLabelAlign.detailAddress"></el-input>
				</el-form-item>
				<el-form-item :label="gudingziduan.PointsMall.Receiver">
					<el-input class="inputs input1" v-model="formLabelAlign.name"></el-input>
				</el-form-item>
				<div class="flex w100">
					<el-form-item :label="gudingziduan.PointsMall.Tel" class="mr-25 w50">
						<el-input class="inputs " v-model="formLabelAlign.phone"></el-input>
					</el-form-item>
					<el-form-item :label="gudingziduan.PointsMall.Email" class="ml-25 w50">
						<el-input class="inputs " v-model="formLabelAlign.email"></el-input>
					</el-form-item>
				</div>
			</el-form>
			<div class="xuanz mb-50">
				<el-checkbox v-model="formLabelAlign.isDefault">
					<!-- Set as default address -->
					{{gudingziduan.PointsMall.Setasdefaultaddress}}
					</el-checkbox>

			</div>
			
			<el-table class="tabbs" :data="tableData" border style="width: 100%">
				<el-table-column align="center" prop="name" :label="gudingziduan.PointsMall.Receiver" width="180" />
				<el-table-column align="center" prop="country" :label="gudingziduan.PointsMall.CountryRegion" width="180" />
				<el-table-column align="center" prop="detailAddress" :label="gudingziduan.PointsMall.DAddress" />
				<el-table-column align="center" prop="phone" :label="gudingziduan.PointsMall.Tel" />
				<el-table-column align="center" prop="email" :label="gudingziduan.PointsMall.Email" />
				<el-table-column align="center" label="Setting">
					<template slot-scope="scope">
						<el-button class="hongg cur_pointer" @click="handleClick(scope.row)" type="text" size="small">{{gudingziduan.PointsMall.DAddress}}</el-button>
						<el-button class="ys-66" type="text" @click="SetUp" size="small">Edit </el-button>
						<el-divider direction="vertical"></el-divider>
						<el-button class="hongg cur_pointer" type="text" size="small" @click="deletedizhi(scope.row)">{{gudingziduan.PointsMall.Delete}}</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="w100 t-center mt-40">
				<div class="flex a-center j-center" style="margin: .65rem auto;">
					<div class="hangan hangan2 cur_pointer" @click="$houtui()">{{gudingziduan.PointsMall.Cancel}}</div>
					<div class="hangan hangan1 cur_pointer ys-0" @click="tianjiadizhi()">{{gudingziduan.PointsMall.Addnewaddress}}</div>
				</div>
			</div>
			
		</div>

		<el-dialog class="add_dia" top="5vh" title="Modify receiving address"  width="60%" :visible.sync="Setupbox">
			<el-form class="adddressform2" label-position="top" label-width="80px" :model="formLabelAlign2">
				
				
				
				
				
				<el-form-item :label="gudingziduan.PointsMall.CountryRegion">
					<el-input class="inputs2 " v-model="formLabelAlign2.country"></el-input>
				</el-form-item>
				<el-form-item :label="gudingziduan.PointsMall.DAddress">
					<el-input class="inputs2" v-model="formLabelAlign2.detailAddress"></el-input>
				</el-form-item>
				<el-form-item :label="gudingziduan.PointsMall.Receiver">
					<el-input class="inputs2" v-model="formLabelAlign2.name"></el-input>
				</el-form-item>
				<div class="flex w100">
					<el-form-item :label="gudingziduan.PointsMall.Tel" class="mr-25 w50">
						<el-input class="inputs2 " v-model="formLabelAlign2.phone"></el-input>
					</el-form-item>
					<el-form-item :label="gudingziduan.PointsMall.Email" class="ml-25 w50">
						<el-input class="inputs2 " v-model="formLabelAlign2.email"></el-input>
					</el-form-item>
				</div>
				
			</el-form>
			<div class="xuanz mb-50">
				<el-checkbox v-model="formLabelAlign2.isDefault">
					<!-- Set as default address -->
					{{gudingziduan.PointsMall.Setasdefaultaddress}}
					
					</el-checkbox>
			
			</div>
			<div class="w100 t-center mt-40">
				<div class="flex a-center j-center" style="margin: .65rem auto;">
					<div class="hangan hangan2 cur_pointer" @click="$houtui()">{{gudingziduan.PointsMall.Cancel}}</div>
					<div class="hangan hangan1 cur_pointer ys-0" @click="dizhixiugai">{{gudingziduan.PointsMall.Addnewaddress}}</div>
				</div>
			</div>
		</el-dialog>
		<Foot></Foot>
	</div>
</template>

<script>
	import Tou from '../../../zuzuzu/touss.vue'
	import Foot from '../../../zuzuzu/foot.vue'
	import {dizhiadd,addresslist,dizhiupdate,dizhideleted} from '@/api/PointsMall.js';
	export default {
		data() {
			return {
				radio: 1,
				max: '',
				mail: {},
				checked: false,
				Setupbox: false,
				
				tableData: [{
				          date: 'Solarland-Bayern',
				          name: 'Germany',
				          address: 'Solarland Bayern GmbH Zeppelinstr. 11 85748 Garching',
						  tel:'08971680330',
						  email: 'info@solarland-bayerrn.de'
				        }],
				formLabelAlign: {
				  city: "",
				  country: "",
				  detailAddress: "",
				  email: "",
				  isDefault: true,
				  name: "",
				  phone: "",
				  province: "",
				  region: ""
				},
				formLabelAlign2:{},
				gudingziduan:{},
			}
		},
		components: {
			Tou,
			Foot,
		},
		watch: {
		    '$store.state.cunyuanyan': {
		      handler(newValue, oldValue) {
		        // console.log('语言已更新:', newValue);
		        this.gudingziduan=this.$store.state.cunyuanyan
				// console.log(this.gudingziduan,'video')
		      },
		      deep: true // 如果 cunyuanyan 是对象，需要设置 deep 为 true
		    }
		},
		created(){
			this.$store.commit('Gaiyuyan', this.$store.state.yuyan);
			this.gudingziduan=this.$store.state.cunyuanyan
			this.dizhilie()
		},
		methods: {
			SetUp() {
				this.Setupbox = true
			},
			tianjiadizhi(){//添加地址
				dizhiadd(this.formLabelAlign).then(shu=>{
					this.formLabelAlign={}
					// this.$message(shu.message)
					this.$message({
					  showClose: true,
					  message: shu.message,
					  type: 'success',
					  offset:'350',
					  duration:0
					});
					this.dizhilie()
				})
			},
			dizhixiugai(){//修改地址
				dizhiupdate(this.formLabelAlign2).then(shu=>{
					this.$message({
					  showClose: true,
					  message: shu.message,
					  type: 'success',
					  offset:'350',
					  duration:0
					});
					this.dizhilie()
				})
			},
			deletedizhi(e){//删除地址
				dizhideleted({id:e.id}).then(shu=>{
					this.$message({
					  showClose: true,
					  message: shu.message,
					  type: 'success',
					  offset:'350',
					  duration:0
					});
					this.dizhilie()
				})
			},
			dizhilie(){
				addresslist({name:''}).then(shu=>{
					if(shu.data.length>=1){
						this.tableData=shu.data
					}else{
						this.tableData=[]
					}
				})
			},
			handleClick(e){
				this.Setupbox=true
				// console.log(e)
				this.formLabelAlign2=e
			}
		}	
	}
</script>

<style lang="scss" scoped>
	.address {
		.biaotie span {
			display: inline-block;
			width: .08rem;
			height: .28rem;
			background: #e60012;
			border-radius: 4px;
		}
		.hongg {color: #E60819;}
		::v-deep .inputs .el-input__inner {
			height: .60rem;
			border-radius: .1rem;
		}
		::v-deep .inputs2 .el-input__inner {
			height: .60rem;
			min-height: 40px;
			border-radius: .1rem;
			line-height: initial;
			border: 1px solid #DCDFE6;
		}

		::v-deep .el-input.is-active .el-input__inner {border-color: #e60012;}
		::v-deep .el-input__inner:focus {border-color: #e60012;}
		::v-deep .el-textarea__inner:focus {border-color: #e60012;}
		::v-deep .input1 .el-input__inner {
			width: 48%;
		}

		::v-deep .input2 .el-textarea__inner {
			width: 100%;
			height: 1.39rem;
			border-radius: .1rem;
		}
		.adddressform2 {
			::v-deep .el-form-item__label {font-size: var(--font20);	line-height: initial;}
		}
		.adddressform {
			::v-deep .el-form-item__label {
				margin-top: .1rem;
				font-size: var(--font20);
				line-height: initial;
			}
		}

		::v-deep .xuanz {
			.el-checkbox__inner {
				border-radius: 50%;
			}

			.el-checkbox__input.is-checked .el-checkbox__inner,
			.el-checkbox__input.is-indeterminate .el-checkbox__inner {
				background-color: #E71222;
				border-color: #E71222;
			}

			.el-checkbox__input.is-focus .el-checkbox__inner {
				border-color: #E71222;
			}

			.el-checkbox__input.is-checked+.el-checkbox__label {
				color: #E71222;
			}

			.el-checkbox__label {
				font-size: .2rem;
			}

			.el-checkbox__input {
				line-height: 19px;
			}
		}
		::v-deep .tabbs {
			
			.has-gutter {
				color: #333333;
				.el-table__cell:nth-child(even) {
				  background-color: #D1D1D1;
				}
				.el-table__cell:nth-child(odd) {
				  background-color: #f6f6f8;
				}
			} 
			
		}
		.hangan {border-radius: 100px;margin: 0 .2rem;}
		.hangan1 { background: linear-gradient(-26deg,#e70a16 0%, #ff785c 100%); padding: .14rem .22rem;}
		.hangan2 { background: #F6F6F8;padding: .14rem .4rem;}
		.add_dia {
			::v-deep .el-dialog {padding: .55rem .75rem .01rem;border-radius: .1rem;}
			::v-deep .el-dialog__title {font-size: var(--font30);line-height: .5rem;}
			::v-deep .el-dialog__header,.el-dialog__body {padding: 0;}
			
		}
		// .el-radio__input.is-checked .el-radio__inner{
		// 	border-color: #E60012;
		// 	background: #ffffff;
		// }
		// .el-radio {display: block;margin: 0 .25rem;}
		// .el-radio__inner{width: .24rem;height: .24rem;border-width: 2px;}
		// .el-radio__inner::after {background-color: #E60012;width: .12rem;height: .12rem;}
		// .el-radio__label,.el-radio__input.is-checked+.el-radio__label {font-size: .16rem;color: #666666;}
		// .el-radio {padding: .24rem;display: flex;}
		// .is-checked { background: #f7f7f7; border-radius: 10px;  }
		// .el-radio__label {display: flex;flex: 1;}
		// .el-image {width: 2.46rem; height: 1.59rem; border-radius: 10px;}
		.anniu {
			width: 2.18rem;
			height: .5rem;
			line-height: .5rem;
		}
	}


// ==========================================================================================================================================================================
// 响应式
@media only screen and (max-width:767px) {
	.address .add_dia {
		::v-deep .el-dialog {width: 96% !important;padding: .3rem;}
		::v-deep .el-dialog__body {padding: 0; padding-top: .2rem;}
	}
}


</style>